module.exports = __webpack_public_path__ + "static/img/star.b99290f0.png";